function initTestimonialCards(root) {
  const scope = root || document;
  const sections = scope.querySelectorAll('[data-testimonial-cards]');

  sections.forEach((section) => {
    if (section.dataset.testimonialCardsInit === 'true') return;
    section.dataset.testimonialCardsInit = 'true';

    const slider = section.querySelector('[id^="Slider-"]');
    const fill = section.querySelector('[data-testimonial-progress-fill]');
    const prevButtons = section.querySelectorAll('button[name="previous"]');
    const nextButtons = section.querySelectorAll('button[name="next"]');

    if (!slider) return;

    const desktopMedia = window.matchMedia('(min-width: 990px)');

    function updateStep() {
      const step = desktopMedia.matches ? '3' : '1';
      prevButtons.forEach((button) => {
        button.dataset.step = step;
      });
      nextButtons.forEach((button) => {
        button.dataset.step = step;
      });
    }

    function updateProgress() {
      if (!fill) return;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) {
        fill.style.width = '100%';
        return;
      }
      const progress = (slider.scrollLeft / maxScroll) * 100;
      fill.style.width = `${Math.min(100, Math.max(0, progress))}%`;
    }

    updateStep();
    updateProgress();

    slider.addEventListener('scroll', updateProgress, { passive: true });

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', updateStep);
    } else {
      desktopMedia.addListener(updateStep);
    }

    window.addEventListener('resize', () => {
      updateStep();
      updateProgress();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initTestimonialCards());
document.addEventListener('shopify:section:load', (event) => initTestimonialCards(event.target));
